import React from 'react';
import { _defineHelpUrlandToolTip } from '../../helpers/index.js'

const LogicNegate = function () {
    const name = "logic_negate";
    LogicNegate.blockName = name;

    _defineHelpUrlandToolTip(name, Blockly.BASE_HELP_URL + "#logic");

    return (
        <block type={name}></block>
    );
};

export default LogicNegate;
